const Price = ({ amount, className, currencyCode = 'USD' }) => (
  <p suppressHydrationWarning={true} className={className}>
    {parseFloat(amount) === 0
      ? 'FREE'
      : `${new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currencyCode,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          useGrouping: false
        }).format(Math.floor(parseFloat(amount)))}`}
  </p>
);

export default Price;
